import { z } from "zod"

const jsonObjectSchema = z.record(z.unknown())

export const stringArraySchema = z.array(z.string())

export const stringRecordSchema = z.record(z.string())

const serializedCursorSchema = z.string().nullable().optional()

export const normalizeSerializedCursors = (
  cursors: ReadonlyArray<string | null | undefined>,
): (string | undefined)[] =>
  cursors.map((cursor) => (cursor === null ? undefined : cursor))

export const workosSetupRequestSchema = z.object({
  clerkOrgId: z.string(),
  workosOrgId: z.string(),
  workosDirectoryId: z.string().optional(),
})

export const peaksResponseSchema = z.array(z.tuple([z.number(), z.number()]))

export const runsSessionStateSchema = z
  .object({
    loadedCursors: z.array(serializedCursorSchema),
    scrollOffset: z.number(),
    clickedRowId: z.string(),
    timestamp: z.number(),
    viewMode: z.string(),
  })
  .passthrough()

export const conversationsSessionStateSchema = z
  .object({
    loadedCursors: z.array(serializedCursorSchema),
    scrollOffset: z.number(),
    clickedRowId: z.string(),
    timestamp: z.number(),
    filters: jsonObjectSchema.optional(),
    selectedKeys: z.array(z.string()).optional(),
    selectedRunIdsBySimulationId: stringRecordSchema.optional(),
  })
  .passthrough()

export const savedViewStorageStateSchema = z
  .object({
    loadedViewId: z.string().nullable().optional(),
  })
  .passthrough()
